import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Construction } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const MaintenanceAdmin = () => {
  const [enabled, setEnabled] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    fetch(`${API}/admin/maintenance`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => d && setEnabled(!!d.enabled))
      .catch(() => {});
  }, []);

  const toggle = async () => {
    setBusy(true);
    try {
      const r = await fetch(`${API}/admin/maintenance`, {
        method: "POST", credentials: "include",
        headers: { "Content-Type": "application/json" }, body: JSON.stringify({ enabled: !enabled }),
      });
      if (r.ok) {
        const d = await r.json();
        setEnabled(d.enabled);
        toast.success(d.enabled ? "Maintenance mode ON — public site shows Coming Soon" : "Maintenance mode OFF — site is live");
      }
    } catch { toast.error("Could not update"); } finally { setBusy(false); }
  };

  if (enabled === null) return null;

  return (
    <div className="ws-panel p-4 mb-4 ws-fade-up" data-testid="maintenance-admin">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2.5">
          <div className="ws-icon-chip w-8 h-8"><Construction className={`w-4 h-4 ${enabled ? "text-[#f59e0b]" : "text-[color:var(--ws-muted)]"}`} /></div>
          <div>
            <div className="ws-heading text-[13px] font-bold text-white">Public Site Maintenance</div>
            <div className="text-[11px] text-[color:var(--ws-muted)]">
              {enabled ? "Visitors see “Launching soon”. Logged-in users & backend unaffected." : "Public site is live. Turn on to show a Coming Soon page to visitors."}
            </div>
          </div>
        </div>
        <button onClick={toggle} disabled={busy} data-testid="maintenance-toggle"
          className="relative w-11 h-6 rounded-full transition-colors shrink-0"
          style={{ background: enabled ? "#f59e0b" : "rgba(120,140,180,0.3)" }}>
          <span className="absolute top-0.5 w-5 h-5 rounded-full bg-white transition-all" style={{ left: enabled ? 22 : 2 }} />
        </button>
      </div>
    </div>
  );
};

export default MaintenanceAdmin;
